import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { assignInlineVars } from "@faire/retailer-visitor-shared/lib/tailwindUtils";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useMemo } from "react";
import { toastTopVar, topVar, transitionDurationVar } from "./consts";
var HIDE_COMPONENT_OFFSET_TOP = 300;
export var useStyle = function(param) {
    var nonStickyHeader = param.nonStickyHeader, bannerHeight = param.bannerHeight, isShowingMarketCountdownBanner = param.isShowingMarketCountdownBanner, hasNoTopBanner = param.hasNoTopBanner, notificationPreview = param.notificationPreview, isNotificationPreviewVisible = param.isNotificationPreviewVisible, shouldRetainOriginalPosition = param.shouldRetainOriginalPosition, shouldShowSaleAnnouncementTooltip = param.shouldShowSaleAnnouncementTooltip, contentRef = param.contentRef;
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    return useMemo(function() {
        if (!nonStickyHeader) {
            var _contentRef_current;
            // AddedToBag must not get unmounted when the `hideHeadersAndBanners` prop
            // changes, or otherwise we don't correctly show the added to bag toast
            // after adding a product to cart from the mobile product modal.
            var topPosition = isDesktopAndAbove && isShowingMarketCountdownBanner && !hasNoTopBanner ? bannerHeight : 0;
            // Preview has an absolute position, so we need to account for it
            var notificationPreviewOffset = notificationPreview && isNotificationPreviewVisible ? 100 : 0;
            var salesTooltipOffset = shouldShowSaleAnnouncementTooltip ? 188 : 0;
            var absoluteTopElementsOffset = notificationPreviewOffset + salesTooltipOffset;
            var stickyContentHeight = ((_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.clientHeight) ? contentRef.current.clientHeight + absoluteTopElementsOffset : undefined;
            var hideComponentOffsetTop = stickyContentHeight !== null && stickyContentHeight !== void 0 ? stickyContentHeight : HIDE_COMPONENT_OFFSET_TOP;
            var _obj;
            return assignInlineVars((_obj = {}, _define_property(_obj, topVar.variable, shouldRetainOriginalPosition ? "".concat(topPosition, "px") : "-".concat(hideComponentOffsetTop, "px")), _define_property(_obj, transitionDurationVar.variable, "".concat(hideComponentOffsetTop / HIDE_COMPONENT_OFFSET_TOP * 400, "ms")), _define_property(_obj, toastTopVar.variable, shouldRetainOriginalPosition ? "".concat(topPosition + hideComponentOffsetTop, "px") : "0px"), _obj));
        }
        return undefined;
    }, [
        bannerHeight,
        contentRef,
        hasNoTopBanner,
        isDesktopAndAbove,
        isNotificationPreviewVisible,
        isShowingMarketCountdownBanner,
        nonStickyHeader,
        notificationPreview,
        shouldRetainOriginalPosition,
        shouldShowSaleAnnouncementTooltip
    ]);
};
